import { jsx as _jsx } from "react/jsx-runtime";
import { RouterManager } from "./modules/router/RouterManager";
export var App = function () { return _jsx(RouterManager, {}); };
